import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { SiteCodes, ToolboxTalkModel } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { FormControl, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-config-add-toolbox-talk',
  templateUrl: './config-add-toolbox-talk.component.html',
  styleUrls: ['./config-add-toolbox-talk.component.css']
})
export class ConfigAddToolboxTalkComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<ConfigAddToolboxTalkComponent>,
    private _safetyConfigService:SafetyConfigService,
    public toastr: NotificationsService, vcr: ViewContainerRef

  ) { }

  ToolboxTalkModel:ToolboxTalkModel
  inputValueMonth:number
  inputValueYear:number
  inputValuenumber:number=0
  inputValuestate:number
  siteCodesList: SiteCodes[]=[];

//set current date values
mydate =new Date();


  ngOnInit() {

    this.inputValueYear=this.mydate.getFullYear() 
    this.inputValueMonth=(this.mydate.getMonth() +1);
    this. loadSiteList()
  }

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  DialogClose(){
    this.dialogRef.close(false)
  }

  addToolbox()
  {
    console.log('month' , this.inputValueMonth)
    console.log('year' , this.inputValueYear)
    console.log('number' , this.inputValuenumber)
    let model=new ToolboxTalkModel();
    model.inputValueMonth=this.inputValueMonth;
    model.inputValueYear=this.inputValueYear;
    model.inputValuenumber=this.inputValuenumber;
    model.inputValuestate=this.inputValuestate;
    this._safetyConfigService.addToolBoxTalk(model).subscribe(r=>
      {
        console.log("result", r)
        // if(r=true){
        // this.toastr.success('Saved');
        // }
        // else{
        //   this.toastr.error('Error');
        // }
      })
      this.DialogClose();
  }


  loadSiteList()
 {
   this._safetyConfigService.getAllSitesList().subscribe(sites =>
   { 
     console.log('sitelist',sites)
     this.siteCodesList=sites;
     
   });
 }
  
}
